import {Component, OnInit} from '@angular/core';
import {MessageService} from "primeng/api";
import {LanguageService} from "../../shared/language/language.service";
import {ActivatedRoute, Router} from "@angular/router";
import {EncodeDecode} from "../../shared/encode-decode/EncodeDecode";
import {AuthTokenService} from "../../services/auth-token.service";
import {ToastService} from "../../shared/toast/toast.service";

@Component({
    selector: 'app-maintenance',
    templateUrl: './maintenance.component.html',
    styleUrls: ['./maintenance.component.scss'],
    providers: [MessageService],
    standalone: false
})
export class MaintenanceComponent implements OnInit {

    language: string = 'IN';
    mailEncript !: string;
    user!: string;

    constructor(private __languageService: LanguageService,
                private route: ActivatedRoute,
                private __router: Router,
                private __authService: AuthTokenService,
                public toastService: ToastService,) {
    }

    ngOnInit() {
        this.language = this.route.snapshot.paramMap.get('language')!;
        this.__languageService.setLanguage(this.language);
        this.mailEncript = this.route.snapshot.paramMap.get('email')!;

        try {
            let mail = EncodeDecode.b64DecodeUnicode(this.mailEncript);

            this.__authService.validateAccessUser(mail, 'SOM').subscribe((data: any) => {
                if (data.ac_result != 1) {
                    localStorage.clear();
                    sessionStorage.clear();
                    this.__router.navigate(['/noauthorized']);
                } else {
                    this.user = data.ac_usuario;
                    // this.loadLastAssignments();
                }
            });
        } catch (e) {
            console.log(e);
            localStorage.clear();
            sessionStorage.clear();
            this.__router.navigate(['/noauthorized']);
        }
    }
}
